const companiesList = {
  listBreadcrumb: "Companies",
  searchPlaceholder: "Search Companies",
  statusFilter: "Status",
  allStatuses: "All",
  createdFrom: "Created from",
  createdTo: "Created to",
  companyName: "Company Name",
  companyId: "ID",
  contactPerson: "Contact Person",
  city: "City",
  countryLabel: "Country",
  createdDate: "Created Date",
  numberOfEvents: "No. of Events",
  status: "Status",
  active: "Active",
  deactivated: "Deactivated",
  pending: "Pending",
  rejected: "Rejected",
  viewDetails: "View Details",
  deactivate: "Deactivate",
  activate: "Activate",
  addCompany: "Add Company",
  // Deactivating a company from the Companies list (PROLINE-4124).
  deactivation: {
    menuAction: "Deactivate",
    title: "Deactivate Company Account",
    message:
      "You are about to deactivate {company}. This stops the company using Yoram and cancels its running events.",
    eventsCount: "{count} events will be cancelled",
    eventsCountOne: "1 event will be cancelled",
    warnings: [
      "Every Upcoming and Ongoing event is cancelled and cannot be restored.",
      "Completed and already cancelled events are not affected.",
      "No user of this company will be able to sign in.",
    ],
    reasonLabel: "Reason",
    reasonPlaceholder: "Enter your message here...",
    reasonMaxLengthError: "You can't enter more than 300 characters.",
    detailsTitle: "Company Deactivation",
    detailsDateLabel: "Deactivated on",
    cancel: "Cancel",
    confirm: "Deactivate",
    successTitle: "{company} deactivated",
    successMessage: "{count} events cancelled. The company's users can no longer sign in.",
    successMessageOne: "1 event cancelled. The company's users can no longer sign in.",
  },
  // Activating a deactivated company from the Companies list (PROLINE-4141).
  activation: {
    menuAction: "Activate",
    title: "Activate Company",
    message: "{company} will be able to use Yoram again, and its users can sign in.",
    warningTitle: "The cancelled events are not restored",
    warnings: [
      "The events cancelled by the deactivation stay cancelled.",
      "A cancelled event can never be reopened. The company creates a new event from scratch.",
      "Only the company is reactivated.",
    ],
    cancel: "Cancel",
    confirm: "Activate Company",
    successTitle: "{company} activated",
    successMessage: "The company's users can sign in again.",
  },
  noCompaniesTitle: "No Companies Yet",
  noCompaniesDescription:
    "It looks like you haven't added any companies to your list. Get started by creating your first company profile to manage events and applicants.",
  showingRange: "Showing {from}–{to} of {total} companies",
  editPageTitle: "Edit company",
  editPageHint: "Update the company name fields below.",
  nameEn: "Name (EN)",
  nameAr: "Name (AR)",
  companyProfile: "Company Profile",
  overviewTab: "Overview",
  financialsPayrollTab: "Financials & Payroll",
  pendingRequestsTab: "Pending Requests",
  clientsTab: "Clients",
  teamPermissionsTab: "Team & Permissions",
  logsTab: "Logs",
  subscriptionTab: "Subscription",
  // Company subscription plan and its upgrade by the Super Admin (PROLINE-4122).
  subscription: {
    yearlyPrice: "{price} SAR / year",
    dailyRate: "Daily: {rate} SAR / day",
    extendedRate: "Extended: {rate} SAR for the event",
    startDate: "Start Date: {date}",
    renews: "Renews: {date}",
    changePlan: "Change Plan",
    highestPlan: "This company is on the highest plan.",
    /** Fallbacks when the backend sends no message (PROLINE-4150). */
    changed: "The subscription plan has been changed.",
    changeFailed: "Something went wrong changing the plan. Please try again.",
    /** The company's own view on its profile, read only (PROLINE-4123). */
    companyProfile: {
      title: "Company Subscription",
      changePlanTitle: "Change Your Plan",
      changePlanMessage: "Want to switch plans? Contact our team at {email} and we'll help you.",
    },
    modal: {
      title: "Upgrade Subscription Plan",
      description:
        "Change this company's subscription plan - the new price takes effect immediately.",
      current: "Current:",
      currentValue: "{plan} - {price} SAR / year",
      newPlan: "New Plan",
      newPlanValue: "{plan} (was {current})",
      price: "Price",
      priceValue: "{price} SAR / year - {plan} plan",
      difference: "Difference to Pay",
      differenceValue: "{amount} SAR",
      noticeTitle: "Applies immediately",
      noticeMessage:
        "Your new plan takes effect as soon as you confirm, no approval needed. The price difference above is the difference between the yearly prices of the two plans, and your billing year and renewal date stay the same.",
      confirm: "Confirm Upgrade",
    },
  },
  overviewStatTotalEvents: "Total events",
  overviewStatOngoingEvents: "Ongoing events",
  overviewStatTotalRevenue: "Total revenue",
  overviewStatTotalApplicants: "Total applicants",
  overviewStatCurrency: "SAR",
  editCompanyProfile: "Edit Company Profile",
  generalInformation: "General Information",
  englishName: "English Name",
  arabicName: "Arabic Name",
  cityLabel: "City",
  fullName: "Full Name",
  mobileNumber: "Mobile Number",
  emailAddress: "Email Address",
  commercialRecordLabel: "Commercial Record",
  cannotBeEdited: "Cannot be edited",
  cannotBeEditedEmail: "Cannot be edited",
  documents: "Documents",
  delegationDocument: "Delegation Document",
  idDocument: "ID Document",
  commercialRecordDocument: "Commercial Record (CR Document)",
  download: "Download",
  replace: "Replace",
  removeDocument: "Remove",
  confirmRemoveTitle: "Remove Document",
  confirmRemoveBody: "Are you sure you want to remove this document?",
  logoUploadHint: "JPG, PNG) or SVG. Max 2MB.",
  logoUploadChange: "CHANGE",
  saveChanges: "Save Changes",
  logoUploadFailed: "Logo upload failed. Please try again.",
  commercialRecordUploadFailed:
    "Commercial record upload failed. Please try again.",
  delegationDocumentUploadFailed:
    "Delegation document upload failed. Please try again.",
  idDocumentUploadFailed: "ID document upload failed. Please try again.",
  pendingProfileRequest: "Pending profile request",
  reviewRequest: "Review Request",
  pendingProfileUpdateRequest: "Pending profile update request",
  submittedOn: "Submitted on {date}",
  reviewProfileUpdateRequest: "Review Profile Update Request",
  approveUpdate: "Approve Update",
  rejectUpdateRequest: "Reject Request",
  changesSummary: "Changes Summary",
  changesSummaryLegendNewTitle: "Highlighted fields",
  changesSummaryLegendNewDesc: "Show new values to be updated",
  changesSummaryLegendOldTitle: "Strikethrough text",
  changesSummaryLegendOldDesc: "Show old values to be replaced",
  rejectEditRequestModalTitle: "Reject Edit Request",
  rejectEditRequestModalDescription:
    "Please provide a reason for rejecting this update. This note will be visible to the company administrator.",
  rejectEditRequestReasonLabel: "Reason",
  rejectEditRequestReasonPlaceholder:
    "e.g. Please provide a clearer copy of the documents...",
  confirmRejectEditRequest: "Confirm Rejection",
  totalChanges: "Total Changes",
  totalChangesFields: "{count} fields",
  editRequestLoadError: "Could not load the edit request. Please try again.",
  noActiveEditRequest: "There is no pending profile update request for this company.",
  documentUpdated: "Document updated",
  documentChanges: "Document Changes",
  documentType: "Document Type",
  currentDocument: "Current Document",
  newSubmission: "New Submission",
  previewNew: "Preview New",
  viewCurrent: "View Current",
  viewOldDoc: "View Old Doc",
  noUpdateSubmittedForDocument: "No update submitted for this document",
  requestAccountDeletion: "Request Account Deletion",
};

export default companiesList;
